const workflowCardsData = [
    {
      step: 'step 1',
      title: 'Navigate to HubSpot',
      text: 'Open HubSpot and navigate to the \'Workflow\' section by clicking on the button below.',
    },
    {
      step: 'step 2 (optinal)',
      title: 'Create workflow',
      text: 'Select the workflow you wish to add the custom action to',
    },
    {
      step: 'step 3',
      title: 'Select workflow',
      text: 'Click on \'Create Workflow\ and create a workflow according to your preferences.',
    },
    {
      step: 'step 4',
      title: 'Add custom action',
      text: 'Select your workflow and add an action by clicking on the \'plus\' icon, followed by the \'Update Company.info action\' under Integrated apps > Comapny.info integration',
    },
  ];

export default workflowCardsData;



